import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
    {
        path: '*',
        component: () => import('@/pages/404.vue')
    },
    {
        path: '/index.html',
        redirect: '/home'
    },
    {
        path: '/',
        redirect: '/home'
    },
    {
        name: 'home',
        path: '/home',
        component: () => import('@/pages/home.vue')
    },
    {
        name: 'help',
        path: '/help',
        component: () => import('@/pages/help/main.vue')
    },
    {
        name: 'terms-of-use',
        path: '/terms-of-use',
        component: () => import('@/pages/help/terms-of-use.vue')
    },
    {
        name: 'contact',
        path: '/contact',
        component: () => import('@/pages/contact.vue')
    },
    {
        path: '/account',
        component: () => import('@/pages/account/main.vue'),
        children: [
            {
                path: '/login',
                name: 'account.login',
                component: () => import('@/pages/account/login.vue')
            },
            {
                path: '/join',
                name: 'account.join',
                component: () => import('@/pages/account/join.vue')
            },
            {
                path: '/forget-password',
                name: 'account.forget-password',
                component: () => import('@/pages/account/forget-password.vue')
            }
        ]
    },
    {
        path: '/farms',
        component: () => import('@/pages/farms/main.vue'),
        children: [
            {
                path: '/',
                name: 'farms.list',
                component: () => import('@/pages/farms/list.vue')
            },
            {
                path: 'create',
                name: 'farms.create',
                component: () => import('@/pages/farms/create.vue')
            },
            {
                path: ':id',
                component: () => import('@/pages/farms/farm/main.vue'),
                children: [
                    {
                        path: '/',
                        name: 'farms.overview',
                        component: () => import('@/pages/farms/farm/overview.vue')
                    },
                    {
                        path: 'calendar',
                        name: 'farms.calendar',
                        component: () => import('@/pages/farms/farm/calendar.vue')
                    },
                    {
                        path: 'update',
                        name: 'farms.update',
                        component: () => import('@/pages/farms/farm/update.vue')
                    },
                    {
                        path: 'cycles/create',
                        name: 'farms.cycles.create',
                        component: () => import('@/pages/farms/farm/cycle-create.vue')
                    },
                    {
                        path: 'cycles/:cycle',
                        component: () => import('@/pages/farms/farm/cycle/main.vue'),
                        children: [
                            {
                                path: 'overview',
                                name: 'farms.cycles.overview',
                                component: () => import('@/pages/farms/farm/cycle/overview.vue')
                            },
                            {
                                path: 'pictures',
                                name: 'farms.cycles.pictures',
                                component: () => import('@/pages/farms/farm/cycle/pictures.vue')
                            },
                            {
                                path: 'timeline',
                                name: 'farms.cycles.timeline',
                                component: () => import('@/pages/farms/farm/cycle/timeline.vue')
                            },
                            {
                                path: 'table',
                                name: 'farms.cycles.table',
                                component: () => import('@/pages/farms/farm/cycle/table.vue')
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        };
    }
});
export default router;
